import { AlertType } from '~/types';
import { CHARGER_SERIAL_COL, CHARGE_LOCATION_COL, CYCLE_COUNT_COL, DAYS_IN_SAFER_BATTERY_ADAPTER, EXPIRY_COL, FEMUR_COMMENTS_COL, FEMUR_FLIGHT_DOWN_COL, FEMUR_FLIGHT_UP_COL, GENERIC_STATE_ICON_COL, INSTALLED_ON_COL, INSTALLED_SERIAL_NUMBER_COL, LAST_DISCHARGE_AUTOCYCLE_COL, SERIAL_COL, STANDARD_COLS, VOLTS_COL } from '../genericTableColumns';
import { booleanDisplay } from '../helpers/displays';
import { addAttributeDateDisplays, addBaseProperties, addCycles, addDaysInSaferBatteryAdapter, addElevenYearExpiry, addFemurComments, addGenericState, addInstalledOnIcon, addLastDischargeAutocycle, addLaunchReturn, addNineYearExpiry, addSevenYearExpiry, addStatusDateDisplays } from '../mappers';
import { ACTIVITY_TABLE_HEADERS } from './activities';
export const SAFER_LPGT_BATTERY_TABLE_HEADERS = [
    ...STANDARD_COLS,
    GENERIC_STATE_ICON_COL,
    INSTALLED_SERIAL_NUMBER_COL,
    DAYS_IN_SAFER_BATTERY_ADAPTER,
    LAST_DISCHARGE_AUTOCYCLE_COL,
    EXPIRY_COL
];
export const FEMUR_SAFER_LPGT_BATTERY_TABLE_HEADERS = [
    SERIAL_COL,
    INSTALLED_ON_COL,
    { ...INSTALLED_SERIAL_NUMBER_COL, text: 'Installed SAFER Serial' },
    LAST_DISCHARGE_AUTOCYCLE_COL,
    CYCLE_COUNT_COL,
    EXPIRY_COL,
    FEMUR_FLIGHT_UP_COL,
    FEMUR_FLIGHT_DOWN_COL,
    FEMUR_COMMENTS_COL
];
export const ACTIVITY_SAFER_LPGT_BATTERY_TABLE_HEADERS = [
    ...ACTIVITY_TABLE_HEADERS,
    CHARGE_LOCATION_COL,
    CHARGER_SERIAL_COL,
    VOLTS_COL
];
export const transformSaferLpgtBattery = (items = []) => {
    return items
        .map(addAttributeDateDisplays)
        .map(addBaseProperties)
        .map(addFemurComments)
        .map(addGenericState)
        .map(addLastDischargeAutocycle)
        .map(addLaunchReturn)
        .map((item) => {
        const expirationDateText = item.status?.expirationDate?.requirementText.toUpperCase();
        if (expirationDateText === '7 YEARS') {
            return addSevenYearExpiry(item);
        }
        else if (expirationDateText === '9 YEARS') {
            return addNineYearExpiry(item);
        }
        else if (expirationDateText === '11 YEARS') {
            return addElevenYearExpiry(item);
        }
    })
        .map(addStatusDateDisplays)
        .map(addDaysInSaferBatteryAdapter)
        .map(addCycles)
        .map(addInstalledOnIcon)
        .map((item) => {
        const status = item.status;
        // alerts based on status
        const alerts = [
            status?.daysInSaferBatteryAdapter?.alertType,
            status?.lastDischargeDate?.alertType,
            status?.expirationDate?.alertType,
            status?.cycles?.alertType
        ];
        const redAlert = alerts.find((alert) => alert === AlertType.ALERT);
        const orangeAlert = alerts.find((alert) => alert === AlertType.WARNING);
        const rowClass = redAlert ? 'red lighten-3' : orangeAlert ? 'orange lighten-3' : '';
        item.attributes['installedInSaferAdapter'] = booleanDisplay(item?.status?.isInstalledInSaferBatteryAdapter.value);
        return Object.assign({}, item, { rowClass });
    });
};
